/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/button-has-type */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React from 'react';
import Loadable from 'react-loadable';
import { Route, Switch } from 'react-router-dom';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';
import LogInRecover from '../LogInRecover/index';
import PersonnalInformations from '../PersonnalInformations/index';
import CompanyExports from '../CompanyExports/index';
// import AdminData from '../PersonnalInformations/components/AdminData';
// import PedagogicData from '../PersonnalInformations/components/PedagogicData';
// import Semesters from '../PersonnalInformations/components/Semesters';
// import ExamsData from '../PersonnalInformations/components/Exams';
// import Criterias from '../PersonnalInformations/components/Criterias';
import basic from '../Group/components/Basic/GroupCreation';
import subgroups from '../Group/components/SubGroups/SubGroups';
import courseplan from '../Group/components/CoursePlan/CoursePlan';
import content from '../Group/components/Content/Content';
import elearn from '../Group/components/Elearning/Elearning';
import SidebarComment from '../Group/components/CommentSidebar';
// import CompanyInfo from '../Company/index';

const locationHelper = locationHelperBuilder({});

function Loading(props) {
  if (props.error) {
    return (
      <div>
        Error!
        {' '}
        <button onClick={props.retry}>Retry</button>
      </div>
    );
  } if (props.pastDelay) {
    return <h3>Loading...</h3>;
  }
  return null;
}

const userIsNotAuthenticated = connectedRouterRedirect({
  // This sends the user either to the query param route if we have one, or to the landing page if none is specified and the user is already logged in
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/companyall/1',
  allowRedirectBack: false,
  authenticatedSelector: (state) => state.authentication.loggedIn !== true,
  wrapperDisplayName: 'UserIsNotAuthenticated',
});

const userIsAuthenticated = connectedRouterRedirect({
  redirectPath: '/',
  authenticatedSelector: (state) => state.authentication.loggedIn === true,
  wrapperDisplayName: 'UserIsAuthenticated',
});

const userIsAdmin = connectedRouterRedirect({
  redirectPath: (state, ownProps) => '/companyall/1',
  allowRedirectBack: false,
  authenticatedSelector: (state) => state.user?.user?.type === 1,
  wrapperDisplayName: 'userIsAdmin',
});

const TestCompany = Loadable({
  loader: () => import('../Company/components/StudentsList'),
  loading: Loading,
});

const Students = Loadable({
  loader: () => import('../Archive/components/Students'),
  loading: Loading,
});

const Customers = Loadable({
  loader: () => import('../Archive/components/Customers'),
  loading: Loading,
});

const Teachers = Loadable({
  loader: () => import('../Archive/components/Teachers'),
  loading: Loading,
});

const Schools = Loadable({
  loader: () => import('../Archive/components/Schools'),
  loading: Loading,
});

const GroupCompany = Loadable({
  loader: () => import('../Company/components/GroupList'),
  loading: Loading,
});

const Exports = Loadable({
  loader: () => import('../Exports/index'),
  loading: Loading,
});

const Group = Loadable({
  loader: () => import('../Group/index'),
  loading: Loading,
});

const ConnexionAttempts = Loadable({
  loader: () => import('../ConnexionAttempts/index'),
  loading: Loading,
});

const UnitViewer = Loadable({
  loader: () => import('../Units/UnitViewer/index'),
  loading: Loading,
});

const Archive = Loadable({
  loader: () => import('../Archive/index'),
  loading: Loading,
});

const ContentNotation = Loadable({
  loader: () => import('../Group/components/Content/Content'),
  loading: Loading,
});

const FollowUp = Loadable({
  loader: () => import('../Group/components/FollowUp/index'),
  loading: Loading,
});

const Webinaire = Loadable({
  loader: () => import('../Webinaire/index'),
  loading: Loading,
});

/*

const ContentNotation = Loadable({
  loader: () => import('../Group/ContentNotation/index'),
  loading: Loading,
});

/* const GroupListCreation = Loadable({
  loader: () => import("../Group/components/GroupList/GroupCreation"),
  loading: Loading
});

const GroupListManage = Loadable({
  loader: () => import("../Group/components/GroupList/CoursePlan"),
  loading: Loading
});

const GroupListContent = Loadable({
  loader: () => import("../Group/components/GroupList/Content"),
  loading: Loading
});

const GroupListElearning = Loadable({
  loader: () => import("../Group/components/GroupList/Elearning"),
  loading: Loading
}); */

const Progress = Loadable({
  loader: () => import('../Progress/StudentList'),
  loading: Loading,
});

const PlacementTestList = Loadable({
  loader: () => import('../PlacementTestList/TestList'),
  loading: Loading,
});

const Student = Loadable({
  loader: () => import('../Student/StudentList'),
  loading: Loading,
});

const StudentDetails = Loadable({
  loader: () => import('../StudentDetails/index'),
  loading: Loading,
});

const Teacher = Loadable({
  loader: () => import('../Teacher/TeacherList'),
  loading: Loading,
});

const Customer = Loadable({
  loader: () => import('../Customer/CustomerList'),
  loading: Loading,
});

const TestReview = Loadable({
  loader: () => import('../Customer/CustomerList'),
  loading: Loading,
});

const Transfers = Loadable({
  loader: () => import('../Transfers/index'),
  loading: Loading,
});

const Sales = Loadable({
  loader: () => import('../Sales/SalesList'),
  loading: Loading,
});

const Surveys = Loadable({
  loader: () => import('../Surveys/index'),
  loading: Loading,
});

const Semesters = Loadable({
  loader: () => import('../Semesters/SemestersList'),
  loading: Loading,
});

const Agenda = Loadable({
  loader: () => import('../Agenda/index'),
  loading: Loading,
});

const DisplaySession = Loadable({
  loader: () => import('../Agenda/components/ReadSession/DisplaySession'),
  loading: Loading,
});

const DisplayEditSession = Loadable({
  loader: () => import('../Agenda/components/EditSession/DisplayEditSession'),
  loading: Loading,
});

const DisplayAppointment = Loadable({
  loader: () => import('../Agenda/components/ReadAppointment/DisplayAppointment'),
  loading: Loading,
});

const CompanyList = Loadable({
  loader: () => import('../CompanyList/index'),
  loading: Loading,
});

const Codes = Loadable({
  loader: () => import('../Codes/index'),
  loading: Loading,
});

const Questions = Loadable({
  loader: () => import('../Questions/index'),
  loading: Loading,
});

const Modules = Loadable({
  loader: () => import('../Modules/index'),
  loading: Loading,
});

const Admin = Loadable({
  loader: () => import('../Admin/index'),
  loading: Loading,
});

const Units = Loadable({
  loader: () => import('../Units/index'),
  loading: Loading,
});

const Search = Loadable({
  loader: () => import('../Search/index'),
  loading: Loading,
});

const Company = Loadable({
  loader: () => import('../Company/index'),
  loading: Loading,
});

const Books = Loadable({
  loader: () => import('../Books/BookList'),
  loading: Loading,
});

const Resources = Loadable({
  loader: () => import('../Resources/ResourceList'),
  loading: Loading,
});

const Results = Loadable({
  loader: () => import('../Group/components/Results/GroupDetails'),
  loading: Loading,
});

const MergedLevels = Loadable({
  loader: () => import('../Company/components/GroupListMergedLevels'),
  loading: Loading,
});

const DetailsMergedLevels = Loadable({
  loader: () => import('../Group/components/Results/GroupDetailsMergedLevels'),
  loading: Loading,
});

const Courses = Loadable({
  loader: () => import('../Courses/index'),
  loading: Loading,
});

const Notifications = Loadable({
  loader: () => import('../Notifications/index'),
  loading: Loading,
});

const NotificationsMail = Loadable({
  loader: () => import('../NotificationsMail/index'),
  loading: Loading,
});

const NotificationClients = Loadable({
  loader: () => import('../NotificationsClients'),
  loading: Loading,
});

const PhoneBook = Loadable({
  loader: () => import('../PhoneBook/index'),
  loading: Loading,
});

const News = Loadable({
  loader: () => import('../News/index'),
  loading: Loading,
});

const Exams = Loadable({
  loader: () => import('../Exams/index'),
  loading: Loading,
});

const ExamResults = Loadable({
  loader: () => import('../Exams/ExamResults'),
  loading: Loading,
});

const PlacementResults = Loadable({
  loader: () => import('../PlacementResults/index'),
  loading: Loading,
});

const NotificationsIntra = Loadable({
  loader: () => import('../NotificationsIntra/index'),
  loading: Loading,
});

const NotificationsIntraEW = Loadable({
  loader: () => import('../NotificationsIntraEW/index'),
  loading: Loading,
});

const Skills = Loadable({
  loader: () => import('../Group/components/Content/ManageSkills'),
  loading: Loading,
});

const Report = Loadable({
  loader: () => import('../Company/components/Report'),
  loading: Loading,
});

const Attendance = Loadable({
  loader: () => import('../Company/components/Attendance'),
  loading: Loading,
});

const GroupAttendance = Loadable({
  loader: () => import('../Group/components/Attendance/Attendance'),
  loading: Loading,
});

const GroupsProposal = Loadable({
  loader: () => import('../Company/components/GroupsProposal'),
  loading: Loading,
});

const Documents = Loadable({
  loader: () => import('../Company/components/Documents'),
  loading: Loading,
});

const RepeatList = Loadable({
  loader: () => import('../RepeatList'),
  loading: Loading,
});

const Quiz = Loadable({
  loader: () => import('../Quiz'),
  loading: Loading,
});

const Absences = Loadable({
  loader: () => import('../Edusign/Absences/index'),
  loading: Loading,
});

const Planning = Loadable({
  loader: () => import('../Edusign/Planning/index'),
  loading: Loading,
});

const EndingFormations = Loadable({
  loader: () => import('../Edusign/EndingFormations/index'),
  loading: Loading,
});

const Survey = Loadable({
  loader: () => import('../Company/components/Survey/index'),
  loading: Loading,
});

const wrappedGroupRoutes = () => (
  <div>
    <Group />
    <SidebarComment>
      <div className="container__wrap_company_edit">
        <Route path="/company/groups/:id/edit/basic" component={basic} />
        <Route path="/company/groups/:id/edit/subgroups" component={subgroups} />
        <Route path="/company/groups/:id/edit/elearning" component={elearn} />
        <Route path="/company/groups/:id/edit/groupnotation" component={ContentNotation} />
        <Route
          exact
          path="/company/groups/:id/edit/manage"
          component={courseplan}
        />
        <Route
          exact
          path="/company/groups/:id/edit/content"
          component={content}
        />
      </div>
    </SidebarComment>
  </div>
);

const wrappedCompanyRoutes = () => (
  <div>
    <Company />
    <div className="container__wrap_company">
      <Route exact path="/company/test/:id" component={TestCompany} />
      <Route exact path="/company/proposal/:id" component={GroupsProposal} />
      <Route exact path="/company/documents/:id" component={Documents} />
      <Route exact path="/company/groups/:id" component={GroupCompany} />
      <Route path="/company/groups/:id/edit" component={wrappedGroupRoutes} />
      <Route path="/company/groups/:id/results" component={Results} />
      <Route path="/company/infos/:id/" component={PersonnalInformations} />
      <Route path="/company/exports/:id/" component={CompanyExports} />
      <Route path="/company/survey/:id/:name" component={Survey} />
      {/* <Route path="/company/infos/admin/:id/" component={AdminData} />
      <Route path="/company/infos/pedagogic/:id/" component={PedagogicData} />
      <Route path="/company/infos/semesters/:id/" component={Semesters} />
      <Route path="/company/infos/exams/:id/" component={ExamsData} />
      <Route path="/company/infos/criterias/:id/" component={Criterias} /> */}
      <Route exact path="/company/results/:id" component={MergedLevels} />
      <Route path="/company/results/:id/mergedresults" component={DetailsMergedLevels} />
      <Route path="/company/groups/:id/trainingfollowup" component={FollowUp} />
      <Route path="/company/test/review/:userId" component={TestReview} />
    </div>
  </div>
);

const wrappedArchiveRoutes = () => (
  <div>
    <Archive />
    <div className="container__wrap_company">
      <Route exact path="/archive/students/" component={userIsAdmin(Students)} />
      <Route exact path="/archive/customers/" component={userIsAdmin(Customers)} />
      <Route exact path="/archive/teachers/" component={userIsAdmin(Teachers)} />
      <Route exact path="/archive/schools/" component={userIsAdmin(Schools)} />
    </div>
  </div>
);

const wrappedRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route exact path="/connexions" component={userIsAdmin(ConnexionAttempts)} />
      <Route exact path="/agenda" component={userIsAdmin(Agenda)} />
      <Route exact path="/edusign/absences" component={userIsAdmin(Absences)} />
      <Route exact path="/edusign/planning" component={userIsAdmin(Planning)} />
      <Route exact path="/edusign/ending-formations" component={userIsAdmin(EndingFormations)} />
      <Route exact path="/student/:studentId" component={StudentDetails} />
      <Route exact path="/student/report/:studentId" component={Report} />
      <Route exact path="/student/attendance/:studentId" component={Attendance} />
      <Route exact path="/group/attendance/:groupId" component={GroupAttendance} />
      <Route exact path="/session/read/:id" component={userIsAdmin(DisplaySession)} />
      <Route exact path="/session/edit/:id/" component={userIsAdmin(DisplayEditSession)} />
      <Route exact path="/session/appointment/:id" component={userIsAdmin(DisplayAppointment)} />
      <Route excat path="/companyall/:type" component={() => <CompanyList />} />
      <Route path="/company" component={wrappedCompanyRoutes} />
      <Route path="/modules" component={userIsAdmin(Modules)} />
      <Route path="/exports" component={userIsAdmin(Exports)} />
      <Route path="/phonebook" component={userIsAdmin(PhoneBook)} />
      <Route path="/courses" component={userIsAdmin(Courses)} />
      <Route path="/repeat" component={userIsAdmin(RepeatList)} />
      <Route path="/transfers" component={userIsAdmin(Transfers)} />
      <Route path="/sales" component={userIsAdmin(Sales)} />
      <Route path="/semesters" component={userIsAdmin(Semesters)} />
      <Route exact path="/placement/results" component={PlacementResults} />
      <Route path="/units" component={userIsAdmin(Units)} />
      <Route path="/unitViewer/:filename/:activityId/:launchPoint" component={userIsAdmin(UnitViewer)} />
      <Route path="/codes" component={userIsAdmin(Codes)} />
      <Route path="/surveys" component={userIsAdmin(Surveys)} />
      <Route path="/questions" component={userIsAdmin(Questions)} />
      <Route path="/archive" component={wrappedArchiveRoutes} />
      <Route path="/notifications" component={userIsAdmin(Notifications)} />
      <Route path="/notificationsMail" component={userIsAdmin(NotificationsMail)} />
      <Route path="/notifClients" component={userIsAdmin(NotificationClients)} />
      <Route path="/notificationsIntra" component={userIsAdmin(NotificationsIntra)} />
      <Route path="/notificationsIntraEW" component={NotificationsIntraEW} />
      <Route path="/news" component={userIsAdmin(News)} />
      <Route path="/placementTestList" component={userIsAdmin(PlacementTestList)} />
      <Route path="/progress" component={userIsAdmin(Progress)} />
      <Route path="/exams" component={userIsAdmin(Exams)} />
      <Route path="/search" component={Search} />
      <Route path="/list" component={userIsAdmin(Exams)} />
      <Route path="/quiz" component={userIsAdmin(Quiz)} />
      <Route path="/results/:examType/:grpId1/:grpId2/:semester/:examId" component={userIsAdmin(ExamResults)} />
      <Route exact path="/books/:search?" component={userIsAdmin(Books)} />
      <Route exact path="/resources/:search?" component={userIsAdmin(Resources)} />
      <Route exact path="/students/:search?" component={Student} />
      <Route exact path="/teachers/:search?" component={userIsAdmin(Teacher)} />
      <Route exact path="/customers/:search?" component={Customer} />
      <Route exact path="/admin" component={userIsAdmin(Admin)} />
      <Route exact path="/skills" component={userIsAdmin(Skills)} />
      <Route exact path="/webinaire" component={userIsAdmin(Webinaire)} />
    </div>
  </div>
);

const Router = ({ user }) => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/" component={userIsNotAuthenticated(LogInRecover)} />
        <Route path="/" component={userIsAuthenticated(wrappedRoutes)} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
